<script lang="ts">
  import { page } from "$app/stores";
  import { is_iOS, isAndroid, isBrave } from "$lib/utils";
  import { m } from "$lib/paraglide/messages";
  import type { Product } from "$lib/products";
  import Button from "@brave/leo/src/components/button/button.svelte";
  import Icon from "@brave/leo/src/components/icon/icon.svelte";
  import AppStoreBadge from "$images/app-store-badge.svg?url";
  import PlayStoreBadge from "$images/play-store-badge.svg?url";

  export let product: Product | undefined;

  $: productName = product?.baseNameEn;

  const createTrackingEvent = (platform: string) => () => {
    if (!product) return;

    const intent = $page.url.searchParams.get("intent");
    const eventCategory = intent ? `${$page.url.pathname}?${intent}` : $page.url.pathname;
    const eventAction = `[${productName}] Download Brave button click${platform ? ` (${platform})` : ""}`;
    const eventName = `[${productName}] Download Brave button${platform ? ` (${platform})` : ""}`;

    // @ts-ignore
    window?._paq?.push(["trackEvent", eventCategory, eventAction, eventName]);
  };
</script>

<aside class="grid max-sm:grid-rows-[1fr_auto] sm:grid-cols-[1fr_auto] items-center gap-xl p-2xl justify-center">
  <div class="text-large-regular text-text-primary">
    <slot />
  </div>
  {#if !isBrave()}
    {#if is_iOS()}
      <a class="flex justify-center" target="_blank" rel="noopener noreferrer" href="https://apps.apple.com/us/app/id1052879175" on:click={createTrackingEvent("ios")}>
        <img class="max-w-[225px] w-full" src={AppStoreBadge} alt={m.app_store_badge_alt()} />
      </a>
    {:else if isAndroid()}
      <a class="flex justify-center" target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=com.brave.browser" on:click={createTrackingEvent("android")}>
        <img class="max-w-[225px] w-full" src={PlayStoreBadge} alt={m.play_store_badge_alt()} />
      </a>
    {:else}
      <Button size="jumbo" target="_blank" href="https://brave.com/download/now/" onClick={createTrackingEvent("desktop")}>
        {m.download_brave_link()}
        <Icon slot="icon-after" name="brave-icon-release-color" />
      </Button>
    {/if}
  {/if}
</aside>

<style>
  aside {
    background: linear-gradient(90deg, #E9EEFF 0%, #FFE7EF 100%);
  }
</style>
